<template>
    <div class="home">
        <!--  banner    -->
        <div class="banner-box">
            <el-carousel class="banner-carousel" :interval="5000"  indicator-position="none">
                <el-carousel-item class="banner-carousel-item" v-for="(item,i) in bannerLists" :key="i">
                    <div style="width: 100%;height: 100%;" ref="bannerImg">
                        <img class="banner-img cursor-pointer" @click="handleBannerDetail(item)"   :src="item.picUrl">
                    </div>
                </el-carousel-item>
            </el-carousel>
            <!-- 滚动通知 -->
            <ScrollNotice />
        </div>
        <!--   图片集   -->
        <div class="imgs-box flex flex-space-center">
            <div class="cursor-pointer" @click="handleImgDetail(1)"> <img src="@/assets/imgs/index1.png"></div>
            <div class="cursor-pointer" @click="handleImgDetail(2)"> <img src="@/assets/imgs/update/Group 8726.png"></div>
            <div class="img-infos academic-lists">
                <div class="information-left-tit flex flex-space-between">
                    <label class="font-style-s">【学术活动】</label>
                    <i class="cursor-pointer" @click="handleImgDetail(3)">更多</i>
                </div>
                <ul>
                    <li v-for="item in academicLists"
                        :key="item.id"
                        @click='handleZxDetail(item)'
                        class="flex flex-align-center">
                        <div class="zx-left">
                            <h4>{{item.month}}.{{item.day}}</h4>
                            <p>{{item.year}}</p>
                        </div>
                        <i/>
                        <div class="line-clamp1 information-text">{{item.title}}</div>

                    </li>
                </ul>
            </div>
            <div class="img-infos">
                <div class="information-left-tit flex flex-space-between">
                    <label class="font-style-s">【文博资讯】</label>
                    <i class="cursor-pointer" @click="handleZX()">更多</i>
                </div>
                <ul>
                    <li v-for="item in zxLists"
                        :key="item.id"
                        @click='handleZxDetail(item)'
                        class="flex flex-align-center">
                        <div class="zx-left">
                            <h4>{{item.month}}.{{item.day}}</h4>
                            <p>{{item.year}}</p>
                        </div>
                        <i/>
                        <div class="line-clamp1 information-text">{{item.title}}</div>

                    </li>
                </ul>
            </div>
        </div>

        <!-- 【馆藏文物】 -->
        <div class="cultural-relic tc">
            <h3 class="font-style-s">【精选文物】</h3>
            <!--    文物輪播      -->
            <div class="swiper-box">
                <div class="swiper-left" @click="handleSwiperLeft">
                    <i class="el-icon-arrow-left" ></i>
                </div>
                <el-carousel ref="swiperListsRef"
                             class="swiper-lists"
                             height="592px"
                             loop
                             indicator-position="none"
                             :autoplay="true">
                    <el-carousel-item v-for="(item,u) in wwLists"  :key="u">
                        <div class="swiper-lists-box  flex ">
                            <div v-for="(key,i) in item" :key="i" class="label block flex flex-align-center">
                                <router-link :to="'/cultural-relics/detail?id='+key.id">
                                    <img :src="key.cover"><i class="font-style-s">{{key.title}}</i>
                                </router-link>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
                <div class="swiper-right" @click="handleSwiperRight">
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>

            <!--    活动    -->
            <div class="active-box-wrap">
                <h3 class="font-style-s">【展览展馆】</h3>
                <div class="new-article-box">
                    <div class="new-article-item"
                         @click="handleNewArticle(item.id)"
                         v-for="item in list1"
                         :key="item.id">
                        <img :src="item.cover" alt="">
                        <div class="new-article-item-text">
                            {{ item.title }}
                        </div>
                        <div class="new-article-item-sub-text">
                            {{ item.hallTitle }}
                        </div>
                    </div>
                    <div class="new-article-item"
                         @click="handleNewArticle('extra')">
                        <img src="/image/lbui.png" alt="">
                        <div class="new-article-item-text">
                            顺昌大圣文化历史遗存图片展
                        </div>
                        <div class="new-article-item-sub-text">
                            一楼大厅环形通道
                        </div>
                    </div>
                    <div class="new-article-item"
                         @click="handleNewArticle(item.id)"
                         v-for="item in list2"
                         :key="item.id">
                        <img :src="item.cover" alt="">
                        <div class="new-article-item-text">
                            {{ item.title }}
                        </div>
                        <div class="new-article-item-sub-text">
                            {{ item.hallTitle }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--   微信小程序的弹窗     -->
        <Dialog :dialog-visible.sync="dialog" title="票务预约"  :show-submit-btn="false">
            <p style="color:#202020;font-size:30px;display: flex;justify-content: center;">扫描二维码</p>
            <p style="color:#202020;font-size:30px;display: flex;justify-content: center;">进行票务预约</p>
            <img style="width: 300px; height: 300px;" class="img-box" src="@/assets/imgs/update/code.png">
        </Dialog>
        <!-- 留言 -->
        <div class="liuyan-box" @click="handleLuiyan">
            <i class="el-icon-chat-line-round"></i>
            互动留言
        </div>
    </div>
</template>
<script setup>
// 响应式状态
import { onMounted, reactive, ref, toRefs } from 'vue';
import { useRouter } from 'vue-router/composables';
import { articleLists, classification, antiqueLists, getHomeBanner, exhibitLists } from '@/api/index';
import moment from 'moment';
import Dialog from '@/components/dialog.vue';
import ScrollNotice from '@/components/scrollNotice.vue';
import { MessageBox } from 'element-ui';
import { useStore } from '@/util';

const router = useRouter();
const store = useStore();
const dialog = ref(false);
const state = reactive({
    culturalRelicLists: [ ],
    culturalRelic: 1,
    zxLists: [],
    academicLists: [],
    wwLists: [],
    bannerLists: []
});

const swiperListsRef = ref(null);

const handleSwiperLeft = () => {
    swiperListsRef.value.prev();
};
const handleSwiperRight = () => {
    swiperListsRef.value.next();
};

// 跳转资讯
const handleZX = () => {
    router.push('/information');
};
// 跳转资讯详情
const handleZxDetail = (item) => {
    if (item.wechatUrl) {
        window.open(item.wechatUrl, '_blank');
    } else {
        store.commit('setActiveRouteName', 'Information');
        router.push('/information/detail?id=' + item.id);
    }

};

// const goNextPage = (url) => {
//     router.push(url);
// };

// 获取资讯列表
const getZxLists = () => {
    articleLists({
        pageNo: 1,
        pageSize: 3,
        categoryId: 2
    }).then(({ data }) => {
        const _data = data?.list || [];

        _data.forEach(element => {
            element.year = moment(element.createTime).format('YYYY');
            element.month = moment(element.createTime).format('MM');
            element.day = moment(element.createTime).format('DD');
        });

        state.zxLists = _data;
    });

};
// 获取资讯列表
const getAcademicLists = () => {
    articleLists({
        pageNo: 1,
        pageSize: 3,
        categoryId: 13
    }).then(({ data }) => {
        const _data = data?.list || [];

        _data.forEach(element => {
            element.year = moment(element.createTime).format('YYYY');
            element.month = moment(element.createTime).format('MM');
            element.day = moment(element.createTime).format('DD');
        });

        state.academicLists = _data;
    });

};


// 获取文物分类
const getWwTypes = () => {

    classification().then(s => {
        state.culturalRelicLists = s.data || [];
        if (s.data.length > 0) {
            state.culturalRelic = s.data[0].classification;
            getWwLists();
        }
    });
};

function chunkArray (array, size) {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
    }
    return result;
}

// 获取文物列表
const getWwLists = () => {
    antiqueLists({
        pageNo: 1,
        pageSize: 9,
        classification: state.culturalRelic
    }).then(({ data }) => {
        const _data = chunkArray(data?.list || [], 3);

        state.wwLists = _data;
    });

};
const bannerImg = ref(null);
const getBanner = () => {
    getHomeBanner({ position: 1 }).then(({ data }) => {
        state.bannerLists = data;
    });
};

const handleBannerDetail = (item) => {
    router.push(item.url);
};

const { zxLists, wwLists, bannerLists, academicLists } = toRefs(state);

const handleNewArticle = (type) => {
    if (type === 'extra') {
        router.push('/exhibition-extra');
        return;
    }
    router.push('/new-article-details?type=' + type);
};

const handleLuiyan = () => {
    router.push('/luiyan');
};

const handleImgDetail = (index) => {
    if (index === 1) {
        // window.open('https://www.qofo360.com/jinlin/bsfjq/index.html', '_blank')
        MessageBox.alert('正在建设中～', '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            showConfirmButton: false
        });
    } else if (index === 2) {
        dialog.value = true;
    } else if (index === 3) {
        router.push('/academic');
    }
};

const list1 = ref([]);
const list2 = ref([]);
const getLists = () => {
    exhibitLists({
        pageNo: 1,
        pageSize: 10,
        type: 1
    }).then(({ data }) => {
        list1.value = data.list;
    });
    exhibitLists({
        pageNo: 1,
        pageSize: 10,
        type: 2
    }).then(({ data }) => {
        list2.value = data.list;
    });
};
// 生命周期钩子
onMounted(() => {
    getZxLists();
    getWwTypes();
    getBanner();
    getLists();
    getAcademicLists();
    // 获取图片的高度
    // setTimeout(() => {
    //     state.bannerImgHeight = bannerImg.value[0].offsetHeight;
    // }, 500);

});
</script>
<style scoped lang="scss">
.banner-box {
    width: 100%;
    min-height: 1080px;
    margin-top: -109px;
    position: relative;
    .banner-carousel {
        height: 1080px;
        ::v-deep .el-carousel__container {
            height: 1080px;
        }

        .banner-carousel-item {
            height: 1080px;
        }

    }
    .banner-img{
        width: 100%;
        object-fit: cover;
        height: 100%;
    }
}


.container-box {
    margin: 33px auto;
    .info1{
        width: 326px;
        padding-right: 107px;
    }
    .info2{
        width: 326px;
        padding-right: 47px;
    }
    .info3{
        width: 474px;
        font-family:Source Han Sans CN;
        color:rgba(28, 28, 28, .5);
        font-size:16px;
        line-height: 30px;
    }
    >div{
        //margin: 0 40px;
    }
    h2{
        font-weight:700;
        color:#1c1c1c;
        font-size:36px;
        margin-bottom: 39px;
        position: relative;
        left: -15px;
    }
    p{
        font-family:Source Han Sans CN;
        color:rgba(28, 28, 28, .5);
        font-size:16px;
        margin-bottom: 32px;
    }
    h3{
        font-family:Impact;
        color:#262626;
        font-size:51px;
        margin-bottom: 19px;
    }

}

.img-box{
    width: 1550px;
    margin:30px auto 30px;
    img{
        width:106px;
        height:106px;
    }
}

.cultural-relic{
    h3{
        font-weight:700;
        color:#1c1c1c;
        font-size:36px;
    }

    &-lists{
        margin: 37px auto;
        label{
            //width:98px;
            height:40px;
            padding: 0 20px;
            display: inline-block;
            margin: 0 19px;
            line-height: 40px;
            text-align: center;
            color:#414141;
            font-size:24px;
            cursor: pointer;
            background-image: url("~@/assets/imgs/ex3.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;

            &.checked{
                border-color:#8b3527 !important;
                background:#8b3527 ;
                color:#f6f6f6 !important;
            }

            &:hover{
                background-image: url("~@/assets/imgs/ex4.png");
                color:#8b3527;
                cursor: pointer;
            }
            &.active{
                background-image: url("~@/assets/imgs/ex2.png");
                color:#fff;
            }
        }
    }

    .swiper-box{
        margin-top: 60px;
        background: url("~@/assets/imgs/Group1166.png");
        height:688px;
        background-size: contain;
        width: 100%;
        position: relative;

        ::v-deep .el-carousel__arrow--left{
            display: none !important;
        }
        ::v-deep .el-carousel__arrow--right{
            display: none !important;
        }
        ::v-deep .el-carousel__item{
            height: auto !important;
        }
        .swiper-lists{
            width: 1231px;
            height:592px;
            overflow: hidden;
            margin: auto;
            position: relative;
            top:43px;
            z-index: 999;

            .swiper-lists-box{
                gap: 44px;
                .label{
                    width:381px;
                    height:592px;
                    background:url("~@/assets/imgs/Subtraction47.png") no-repeat;
                    background-size: 100% 100%;
                    position: relative;
                    text-align: center;
                    cursor: pointer;
                    overflow: hidden;
                    //background: #ffffff;


                    &:hover{
                        img{
                            top: -50px;

                        }
                    }

                    img{
                        width: 100%;
                        max-height: 70%;
                        //background: #42b983;
                        margin: auto;
                        position: relative;
                        top: 0;
                        transition: all 0.25s ease;
                    }

                    i{
                        font-weight:700;
                        color:#232323;
                        font-size:19px;
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: 74px;
                        font-style: normal;
                    }
                }
            }
        }
        .swiper-left,.swiper-right{
            border: none;
            outline: 0;
            padding: 0;
            margin: 0;
            height: 50px;
            width: 50px;
            cursor: pointer;
            -webkit-transition: .3s;
            transition: .3s;
            border-radius: 50%;
            background-color: rgba(31,45,61,.11);
            color: #FFF;
            position: absolute;
            top: 50%;
            z-index: 10;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            text-align: center;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .swiper-left{
            left: 150px;
        }
        .swiper-right{
            right: 150px;
        }
    }
}

.active-box{
    width: 1580px;
    // height: 767px;
    margin:56px auto 142px;
    display: flex;
    gap: 24px;

    .active-list{
        flex: 1;
        // width: 388px;
        // height:716px;
        box-sizing: border-box;
        position: relative;
        background-size: 101% auto;
        cursor: pointer;
        transition: all 0.25s ease;

        img{
            width: 100%;
        }

        &:hover{
            height: 761px;

            .a{
                display: block !important;
            }
        }

        p{
            font-weight:700;
            color:#ffffff;
            font-size:34px;
            width:34px;
        }

        .a{
            width:130px;
            height:40px;
            border:1px solid rgba(#f6f6f6,.7);
            color:rgba(#f6f6f6,.7);
            font-size:24px;
            text-align: center;
            line-height: 40px;
            text-decoration: none;
            position: absolute;
            bottom: 24px;
            left: 33px;
            display: none;
        }
    }
}
.imgs-box{
    margin-top: 40px;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 62px;
    >div{
        width: 744px;
        height: 453px;

        img{
            width: 100%;
            height: 100%;
            font-size: 0;
        }
    }
    .img-infos {
        background:#857B53;
        background-size: 100% 100%;
        padding: 32px 0;
        box-sizing: border-box;

        .information-left-tit {
            font-weight: 700;
            color: #ffffff;
            font-size: 36px;
            padding: 0 40px 0 20px;

            i {
                font-style: normal;
                width: 98px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                color: #ffffff;
                font-size: 24px;
                font-weight: normal;
                background: url("~@/assets/imgs/ex3.png") no-repeat;
                background-size: 100% 100%;
            }
        }

        ul {
            margin-top: 50px;
            color: #ffffff;
            padding: 0px 40px;

            li {
                padding-bottom: 12px;
                border-bottom: 1px dotted rgba(255, 255, 255, .4);
                padding-top: 12px;

                .information-text {
                    width: calc(100% - 110px);
                }
            }

            .zx-left {
                line-height: 23px;
                h4 {
                    font-weight: 700;
                    color: #ffffff;
                    font-size: 24px;
                }

                p {
                    font-weight: 700;
                    color: #ffffff;
                    font-size: 14px;
                }
            }

            i {
                height: 40px;
                width: 1px;
                background: #ffffff;
                display: inline-block;
                margin: 0 38px;
            }
        }
        &.academic-lists {
            background-image: url("/image/academic.jpg");
            background-size: 100%;
            background-repeat: no-repeat;
            background-position: center;
        }
    }
}
.active-box-wrap{
    h3{
        font-weight:700;
        color:#1c1c1c;
        font-size:36px;
        margin-top: 70px;
    }
}
.new-article-box {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    text-align: left;
    margin-top: 50px;
    margin-bottom: 120px;
    padding: 0 40px;
    .new-article-item {
        cursor: pointer;
        img {
            width: 100%;
        }
    }
    .new-article-item-text {
        font-weight:700;
        color:#262626;
        font-size:20px;
        margin-top: 1px;
    }
    .new-article-item-sub-text {
        font-weight:700;
        color:rgba(38, 38, 38, 0.522);
        font-size:14px;
        margin-top: 3px;
    }
}
.liuyan-box {
    position: fixed;
    top: 50%;
    right: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width:105px;
    height:105px;
    background:#675241;
    color: #fff;
    font-size:18px;
    margin-top: 70px;
    z-index: 10;
    cursor: pointer;
    i {
        font-size: 36px;
        margin-bottom: 10px;
    }
}
</style>
